var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBullePenseePersonnageMob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.895,
    height: 92.892,
    viewBox: "0 0 92.895 92.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_132",
    "data-name": "Groupe 132",
    transform: "translate(-280.685 -1135.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_131",
    "data-name": "Groupe 131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_35",
    "data-name": "Groupe 35",
    transform: "translate(327.133 1135.417)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_360",
    "data-name": "Rectangle 360",
    width: 11.611,
    height: 23.224,
    transform: "translate(23.224 11.611)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    "data-name": "Rectangle 363",
    width: 11.614,
    height: 23.224,
    transform: "translate(11.611 11.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_364",
    "data-name": "Rectangle 364",
    width: 11.611,
    height: 23.224,
    transform: "translate(34.835 11.611)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365",
    "data-name": "Rectangle 365",
    width: 23.224,
    height: 11.611,
    transform: "translate(11.611 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_366",
    "data-name": "Rectangle 366",
    width: 23.224,
    height: 11.611,
    transform: "translate(11.611 34.835)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    width: 11.611,
    height: 23.224,
    transform: "translate(0 11.611)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_36",
    "data-name": "Groupe 36",
    transform: "translate(280.685 1181.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_120",
    "data-name": "Trac\\xE9 120",
    d: "M1730.2,1771.7v11.614h11.611v-23.224H1730.2Z",
    transform: "translate(-1706.978 -1748.476)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_122",
    "data-name": "Trac\\xE9 122",
    d: "M1691.421,1771.7v11.614h11.614v-23.224h-11.614Z",
    transform: "translate(-1679.811 -1748.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_124",
    "data-name": "Trac\\xE9 124",
    d: "M1768.973,1771.7v11.614h11.614v-23.224h-11.614Z",
    transform: "translate(-1734.138 -1748.476)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    width: 23.224,
    height: 11.611,
    transform: "translate(11.611)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 23.224,
    height: 11.611,
    transform: "translate(11.611 34.835)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 11.611,
    height: 23.224,
    transform: "translate(0 11.611)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullePenseePersonnageMob);
export default __webpack_public_path__ + "static/media/bulle_pensee_personnage_mob.c0dbdf5c0bc95304503e39a559b7e5a1.svg";
export { ForwardRef as ReactComponent };